import React, { useRef, useState } from "react";
import api from "../utils/api";
import { toast } from "react-toastify";

export default function ManualTransactionForm({ onTransactionAdded }) {
  const [form, setForm] = useState({
    date: "",
    type: "income",
    company: "",
    category: "Uncategorised",
    description: "None",
    amount: "",
    file: null,
  });

  const fileInputRef = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const f = e.target.files && e.target.files[0] ? e.target.files[0] : null;
    setForm((prev) => ({ ...prev, file: f }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.date || !form.amount) {
      toast.error("Date and amount are required");
      return;
    }

    const parsed = parseFloat(form.amount);
    if (Number.isNaN(parsed)) {
      toast.error("Amount must be a valid number");
      return;
    }

    // Convert amount to negative if type is expense
    const finalAmount =
      form.type === "expense" ? -Math.abs(parsed) : Math.abs(parsed);

    const hasFile = form.file instanceof File;

    try {
      if (hasFile) {
        const formData = new FormData();
        formData.append("date", form.date);
        formData.append("type", form.type);
        formData.append("company", form.company);
        formData.append("category", form.category);
        formData.append("description", form.description);
        formData.append("amount", String(finalAmount));
        formData.append("file", form.file);

        await api.post("/transactions", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      } else {
        await api.post("/transactions", {
          date: form.date,
          type: form.type,
          company: form.company,
          category: form.category,
          description: form.description,
          amount: finalAmount,
        });
      }

      toast.success("Transaction added successfully!");

      setForm({
        date: "",
        type: "income",
        company: "",
        category: "Uncategorised",
        description: "None",
        amount: "",
        file: null,
      });

      // Clear the real file input element
      if (fileInputRef.current) fileInputRef.current.value = "";

      if (onTransactionAdded) onTransactionAdded();
    } catch (err) {
      console.error(err);
      toast.error("Failed to add transaction");
    }
  };

  return (
    <div className="card mt-4 p-3">
      <h5>Add Transaction Manually</h5>
      <form onSubmit={handleSubmit} className="row g-3 mt-2">
        <div className="row g-3 mt-2">
          <div className="col-md-2">
            <label htmlFor="date">Date</label>
            <input
              id="date"
              type="date"
              name="date"
              className="form-control"
              value={form.date}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-2">
            <label htmlFor="type">Transaction Type</label>
            <select
              id="type"
              name="type"
              className="form-select"
              value={form.type}
              onChange={handleChange}
            >
              <option value="income">Income</option>
              <option value="expense">Expense</option>
            </select>
          </div>
          <div className="col-md-2">
            <label htmlFor="type">Company</label>
            <select
              id="company"
              name="company"
              className="form-select"
              value={form.company}
              onChange={handleChange}
            >
              <option value="None">Select</option>
              <option value="Castinvestment">Castinvestment</option>
              <option value="Kerminue">Kerminue</option>
              <option value="Deltahouse">Deltahouse</option>
              <option value="Abaskhiron">Abaskhiron</option>
              <option value="Neuroninvest">Neuroninvest</option>
            </select>
          </div>

          <div className="col-md-2">
            <label htmlFor="category">Category</label>
            <input
              id="category"
              type="text"
              name="category"
              placeholder="Category"
              className="form-control"
              value={form.category}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-3">
            <label htmlFor="description">Description</label>
            <input
              id="description"
              type="text"
              name="description"
              placeholder="Description"
              className="form-control"
              value={form.description}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-2">
            <label htmlFor="amount">Amount</label>
            <input
              id="amount"
              type="number"
              step="0.01"
              name="amount"
              placeholder="Amount"
              className="form-control"
              value={form.amount}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-2">
            <label htmlFor="file">Document upload</label>
            <input
              id="file"
              name="file"
              type="file"
              // className="form-control"
              ref={fileInputRef}
              onChange={handleFileChange}
              // accept="image/*,application/pdf" // optional
            />
          </div>
        </div>

        <div className="col-md-2">
          <button type="submit" className="btn btn-primary w-100">
            Add
          </button>
        </div>
      </form>
    </div>
  );
}
